"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withdrawOneInstruction = exports.withdrawInstruction = exports.depositInstruction = exports.swapInstruction = exports.initializeSwapInstruction = exports.StableSwapInstruction = void 0;
const token_utils_1 = require("@saberhq/token-utils");
const BufferLayout = __importStar(require("@solana/buffer-layout"));
const web3_js_1 = require("@solana/web3.js");
const state_1 = require("../state");
const common_1 = require("./common");
var StableSwapInstruction;
(function (StableSwapInstruction) {
    StableSwapInstruction[StableSwapInstruction["INITIALIZE"] = 0] = "INITIALIZE";
    StableSwapInstruction[StableSwapInstruction["SWAP"] = 1] = "SWAP";
    StableSwapInstruction[StableSwapInstruction["DEPOSIT"] = 2] = "DEPOSIT";
    StableSwapInstruction[StableSwapInstruction["WITHDRAW"] = 3] = "WITHDRAW";
    StableSwapInstruction[StableSwapInstruction["WITHDRAW_ONE"] = 4] = "WITHDRAW_ONE";
})(StableSwapInstruction = exports.StableSwapInstruction || (exports.StableSwapInstruction = {}));
const initializeSwapInstruction = ({ config, adminAccount, tokenA: { adminFeeAccount: adminFeeAccountA, mint: tokenMintA, reserve: tokenAccountA, }, tokenB: { adminFeeAccount: adminFeeAccountB, mint: tokenMintB, reserve: tokenAccountB, }, poolTokenMint, destinationPoolTokenAccount, nonce, ampFactor, fees = state_1.ZERO_FEES, }) => {
    const keys = [
        { pubkey: config.swapAccount, isSigner: false, isWritable: false },
        { pubkey: config.authority, isSigner: false, isWritable: false },
        { pubkey: adminAccount, isSigner: false, isWritable: false },
        { pubkey: adminFeeAccountA, isSigner: false, isWritable: false },
        { pubkey: adminFeeAccountB, isSigner: false, isWritable: false },
        { pubkey: tokenMintA, isSigner: false, isWritable: false },
        { pubkey: tokenAccountA, isSigner: false, isWritable: false },
        { pubkey: tokenMintB, isSigner: false, isWritable: false },
        { pubkey: tokenAccountB, isSigner: false, isWritable: false },
        { pubkey: poolTokenMint, isSigner: false, isWritable: true },
        { pubkey: destinationPoolTokenAccount, isSigner: false, isWritable: true },
        { pubkey: config.tokenProgramID, isSigner: false, isWritable: false },
        { pubkey: web3_js_1.SYSVAR_CLOCK_PUBKEY, isSigner: false, isWritable: false },
    ];
    const dataLayout = (0, token_utils_1.structLayout)([
        BufferLayout.u8("instruction"),
        BufferLayout.u8("nonce"),
        (0, token_utils_1.Uint64Layout)("ampFactor"),
        state_1.FeesLayout,
    ]);
    let data = Buffer.alloc(dataLayout.span);
    {
        const encodeLength = dataLayout.encode({
            instruction: StableSwapInstruction.INITIALIZE,
            nonce,
            ampFactor: ampFactor.toBuffer(),
            fees: (0, state_1.encodeFees)(fees),
        }, data);
        data = data.slice(0, encodeLength);
    }
    return (0, common_1.buildInstruction)({
        config,
        keys,
        data,
    });
};
exports.initializeSwapInstruction = initializeSwapInstruction;
const swapInstruction = ({ config, userAuthority, userSource, poolSource, poolDestination, userDestination, adminDestination, amountIn, minimumAmountOut, }) => {
    const dataLayout = BufferLayout.struct([
        BufferLayout.u8("instruction"),
        (0, token_utils_1.Uint64Layout)("amountIn"),
        (0, token_utils_1.Uint64Layout)("minimumAmountOut"),
    ]);
    const data = Buffer.alloc(dataLayout.span);
    dataLayout.encode({
        instruction: StableSwapInstruction.SWAP,
        amountIn: amountIn.toBuffer(),
        minimumAmountOut: minimumAmountOut.toBuffer(),
    }, data);
    const keys = [
        { pubkey: config.swapAccount, isSigner: false, isWritable: false },
        { pubkey: config.authority, isSigner: false, isWritable: false },
        { pubkey: userAuthority, isSigner: true, isWritable: false },
        { pubkey: userSource, isSigner: false, isWritable: true },
        { pubkey: poolSource, isSigner: false, isWritable: true },
        { pubkey: poolDestination, isSigner: false, isWritable: true },
        { pubkey: userDestination, isSigner: false, isWritable: true },
        { pubkey: adminDestination, isSigner: false, isWritable: true },
        { pubkey: config.tokenProgramID, isSigner: false, isWritable: false },
        { pubkey: web3_js_1.SYSVAR_CLOCK_PUBKEY, isSigner: false, isWritable: false },
    ];
    return (0, common_1.buildInstruction)({
        config,
        keys,
        data,
    });
};
exports.swapInstruction = swapInstruction;
const depositInstruction = ({ config, userAuthority, sourceA, sourceB, tokenAccountA, tokenAccountB, poolTokenMint, poolTokenAccount, tokenAmountA, tokenAmountB, minimumPoolTokenAmount, }) => {
    const dataLayout = BufferLayout.struct([
        BufferLayout.u8("instruction"),
        (0, token_utils_1.Uint64Layout)("tokenAmountA"),
        (0, token_utils_1.Uint64Layout)("tokenAmountB"),
        (0, token_utils_1.Uint64Layout)("minimumPoolTokenAmount"),
    ]);
    const data = Buffer.alloc(dataLayout.span);
    dataLayout.encode({
        instruction: StableSwapInstruction.DEPOSIT,
        tokenAmountA: tokenAmountA.toBuffer(),
        tokenAmountB: tokenAmountB.toBuffer(),
        minimumPoolTokenAmount: minimumPoolTokenAmount.toBuffer(),
    }, data);
    const keys = [
        { pubkey: config.swapAccount, isSigner: false, isWritable: false },
        { pubkey: config.authority, isSigner: false, isWritable: false },
        { pubkey: userAuthority, isSigner: true, isWritable: false },
        { pubkey: sourceA, isSigner: false, isWritable: true },
        { pubkey: sourceB, isSigner: false, isWritable: true },
        { pubkey: tokenAccountA, isSigner: false, isWritable: true },
        { pubkey: tokenAccountB, isSigner: false, isWritable: true },
        { pubkey: poolTokenMint, isSigner: false, isWritable: true },
        { pubkey: poolTokenAccount, isSigner: false, isWritable: true },
        { pubkey: config.tokenProgramID, isSigner: false, isWritable: false },
        { pubkey: web3_js_1.SYSVAR_CLOCK_PUBKEY, isSigner: false, isWritable: false },
    ];
    return (0, common_1.buildInstruction)({
        config,
        keys,
        data,
    });
};
exports.depositInstruction = depositInstruction;
const withdrawInstruction = ({ config, userAuthority, poolMint, sourceAccount, tokenAccountA, tokenAccountB, userAccountA, userAccountB, adminFeeAccountA, adminFeeAccountB, poolTokenAmount, minimumTokenA, minimumTokenB, }) => {
    const dataLayout = BufferLayout.struct([
        BufferLayout.u8("instruction"),
        (0, token_utils_1.Uint64Layout)("poolTokenAmount"),
        (0, token_utils_1.Uint64Layout)("minimumTokenA"),
        (0, token_utils_1.Uint64Layout)("minimumTokenB"),
    ]);
    const data = Buffer.alloc(dataLayout.span);
    dataLayout.encode({
        instruction: StableSwapInstruction.WITHDRAW,
        poolTokenAmount: poolTokenAmount.toBuffer(),
        minimumTokenA: minimumTokenA.toBuffer(),
        minimumTokenB: minimumTokenB.toBuffer(),
    }, data);
    const keys = [
        { pubkey: config.swapAccount, isSigner: false, isWritable: false },
        { pubkey: config.authority, isSigner: false, isWritable: false },
        { pubkey: userAuthority, isSigner: true, isWritable: false },
        { pubkey: poolMint, isSigner: false, isWritable: true },
        { pubkey: sourceAccount, isSigner: false, isWritable: true },
        { pubkey: tokenAccountA, isSigner: false, isWritable: true },
        { pubkey: tokenAccountB, isSigner: false, isWritable: true },
        { pubkey: userAccountA, isSigner: false, isWritable: true },
        { pubkey: userAccountB, isSigner: false, isWritable: true },
        { pubkey: adminFeeAccountA, isSigner: false, isWritable: true },
        { pubkey: adminFeeAccountB, isSigner: false, isWritable: true },
        { pubkey: config.tokenProgramID, isSigner: false, isWritable: false },
        { pubkey: web3_js_1.SYSVAR_CLOCK_PUBKEY, isSigner: false, isWritable: false },
    ];
    return (0, common_1.buildInstruction)({
        config,
        keys,
        data,
    });
};
exports.withdrawInstruction = withdrawInstruction;
const withdrawOneInstruction = ({ config, userAuthority, poolMint, sourceAccount, baseTokenAccount, quoteTokenAccount, destinationAccount, adminDestinationAccount, poolTokenAmount, minimumTokenAmount, }) => {
    const withdrawOneDataLayout = BufferLayout.struct([
        BufferLayout.u8("instruction"),
        (0, token_utils_1.Uint64Layout)("poolTokenAmount"),
        (0, token_utils_1.Uint64Layout)("minimumTokenAmount"),
    ]);
    const data = Buffer.alloc(withdrawOneDataLayout.span);
    withdrawOneDataLayout.encode({
        instruction: StableSwapInstruction.WITHDRAW_ONE,
        poolTokenAmount: poolTokenAmount.toBuffer(),
        minimumTokenAmount: minimumTokenAmount.toBuffer(),
    }, data);
    const keys = [
        { pubkey: config.swapAccount, isSigner: false, isWritable: false },
        { pubkey: config.authority, isSigner: false, isWritable: false },
        { pubkey: userAuthority, isSigner: true, isWritable: false },
        { pubkey: poolMint, isSigner: false, isWritable: true },
        { pubkey: sourceAccount, isSigner: false, isWritable: true },
        { pubkey: baseTokenAccount, isSigner: false, isWritable: true },
        { pubkey: quoteTokenAccount, isSigner: false, isWritable: true },
        { pubkey: destinationAccount, isSigner: false, isWritable: true },
        { pubkey: adminDestinationAccount, isSigner: false, isWritable: true },
        { pubkey: config.tokenProgramID, isSigner: false, isWritable: false },
        { pubkey: web3_js_1.SYSVAR_CLOCK_PUBKEY, isSigner: false, isWritable: false },
    ];
    return (0, common_1.buildInstruction)({
        config,
        keys,
        data,
    });
};
exports.withdrawOneInstruction = withdrawOneInstruction;
//# sourceMappingURL=swap.js.map